"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    listStyle: prop_types_1.default.string,
    listStyleType: prop_types_1.default.string,
    listStyleImage: prop_types_1.default.string,
    listStylePosition: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const listStyle = {
    className: 'ls',
    cssName: 'list-style',
    jsName: 'listStyle',
    complexValue: true
};
const listStyleType = {
    className: 'ls-typ',
    cssName: 'list-style-type',
    jsName: 'listStyleType'
};
const listStyleImage = {
    className: 'ls-img',
    cssName: 'list-style-image',
    jsName: 'listStyleImage',
    complexValue: true
};
const listStylePosition = {
    className: 'ls-pos',
    cssName: 'list-style-position',
    jsName: 'listStylePosition',
    safeValue: true
};
exports.propEnhancers = {
    listStyle: (value) => get_css_1.default(listStyle, value),
    listStyleType: (value) => get_css_1.default(listStyleType, value),
    listStyleImage: (value) => get_css_1.default(listStyleImage, value),
    listStylePosition: (value) => get_css_1.default(listStylePosition, value)
};
//# sourceMappingURL=list.js.map